<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="refundApprovalGroup">

  <div nz-row>
  <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
    <nz-form-item class="mr-md">
      <nz-form-label nzRequired>Refund Approval status</nz-form-label>
      <nz-form-control [nzErrorTip]="'Refund Approval Status is Required'">
        <nz-select required nzPlaceHolder="Refund Status" id="refundStatus" formControlName="refundStatus" (ngModelChange)="refundStatusChange($event)">
          <nz-option *ngFor="let is of refundStatusList" [nzValue]="is.code" [nzLabel]="is.description"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" *ngIf="showrejectionReason">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Rejection Reason
        <span nz-tooltip nzTitle="Rejection Reason">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Rejection Reason is Required'">
        <nz-select required [nzPlaceHolder]="'Rejection Reason'" id="rejectionReason" formControlName="rejectionReason">
          <nz-option *ngFor="let fa of rejectionReasonList" [nzLabel]="fa.description" [nzValue]="fa.code"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>


  <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" *ngIf="showApprovedAmount">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Refund Amount
        <span nz-tooltip nzTitle="Refund Amount">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="errApprovedAmtTpl">
        <input required nz-input id="approvedAmount" formControlName="approvedAmount" placeholder="Refund Amount"/>
        <ng-template #errApprovedAmtTpl let-control>
          <ng-container *ngIf="refundApprovalGroup.get('approvedAmount')?.dirty && refundApprovalGroup.get('approvedAmount')?.hasError('required')">
            Refund Amount is Required
          </ng-container>
          <ng-container *ngIf="refundApprovalGroup.get('approvedAmount')?.dirty && refundApprovalGroup.get('approvedAmount')?.hasError('max')">
              Refund Amount should be less than {{ totalRefundAmount }} - AED
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </div>


  <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24">
    <nz-form-item class="mr-md">
      <nz-form-label> Remarks
        <span nz-tooltip nzTitle="Remarks">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Remarks is Required'">
        <textarea required rows="2" id="remarks" formControlName="remarks" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>

</div>
</form>
